import styled from 'styled-components';

export const DividerWrapper = styled.div`
  width: 0.125rem;
  height: '100%';
  align-self: stretch;

  background-color: white;
`;
